import { Injectable, signal, WritableSignal } from '@angular/core';
import { TicketType } from '../../ticket/models';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  public months: Array<any> = [];
  public fullMonths: Array<any> = [];
  public days: Array<any> = [];

  public years: Array<number> = [];

  public currentTimeString: String = '';

  public projectDomains: Array<any> = [];
  public projectStatus: Array<any> = [];
  public projectTypes: Array<any> = [];

  public projectTechnologys: Array<any> = [];

  public businessModals: Array<any> = [];
  public baseLocations: String[] = [];

  public keySkills: { id: number; name: string }[] = [];

  public skillsDomain: EmpSkillsGroup[] = [];

  public designations: Subsets[] = [];

  public employeeStatusList: Subsets[] = [];

  public employeeCategoryList: Subsets[] = [];

  public sowLocations: Subsets[] = [];

  public deviceStatusList: Subsets[] = [];

  public assetLocationList: Subsets[] = [];

  public deviceMakerList: Subsets[] = [];

  public processorList: Subsets[] = [];

  public ramList: Subsets[] = [];

  public deviceTypeList: Subsets[] = [];

  public numericRegex: RegExp = /^(0|[1-9][0-9]*)$/;

  public employeeCodeRegex: RegExp = /^\s*-?[0-9]{1,6}\s*$/;

  public passwordRegex: RegExp =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/;

  public allocationCategory: any[] = [];

  public roleList: any[] = [];
  public assetEntity: any[] = [];
  public categoryForReports: any[] = [];
  public categoryForAssetReports: any[] = [];
  public employeeExcelColumns: any[] = [];
  public contactsExcelColumns: any[] = [];

  public projectExcelColumns: any[] = [];

  public clientExcelColumns: any[] = [];

  public userExcelColumns: any[] = [];

  public assetExcelColumns: any[] = [];

  public sowExcelColumns: any[] = [];
  public timeForReportFile: string = '';
  public ownerServiceList: any[] = [];
  public reportCategoryList: any[] = [];
  public scheduledTimeList: any[] = [];

  public bankAccount: any[] = [];
  public branch: any[] = [];
  public company: any[] = [];
  public gst: any[] = [];
  public gstType: any[] = [];
  public invoiceType: any[] = [];
  public saleType: any[] = [];
  public invoicesExcelColumns: any[] = [];
  public applicantExcelColumns: any[] = [];
  public campusReportTypes: Subsets[] = [];
  public employeeExitTypeList: SubsetsV2[] = [];
  public employeeExitRemarksList: Subsets[] = [];
  public employeeOpportunityStatus: Subsets[] = [];
  public expenseStatus: any[] = [];
  public expenseCategory: any[] = [];
  public expensePayment: any[] = [];
  public gradeList: (Subsets & { designation?: Subsets[] })[] = [];
  public employeeTypeList: Subsets[] = [];
  public employeeUserExcelColumns: any[] = [];

  // public ticketCategoryList: WritableSignal<any[]> = signal([]);
  public ticketPriorityList: WritableSignal<any[]> = signal([]);
  public ticketStatusList: WritableSignal<any[]> = signal([]);
  public ticketTypeList: WritableSignal<TicketType[]> = signal([]);
  public ticketAssignToList: WritableSignal<any[]> = signal([]);
  public genderList: WritableSignal<any[]> = signal([]);

  constructor() {
    this.months = [
      { id: 0, name: 'Jan' },
      { id: 1, name: 'Feb' },
      { id: 2, name: 'Mar' },
      { id: 3, name: 'Apr' },
      { id: 4, name: 'May' },
      { id: 5, name: 'June' },
      { id: 6, name: 'July' },
      { id: 7, name: 'Aug' },
      { id: 8, name: 'Sept' },
      { id: 9, name: 'Oct' },
      { id: 10, name: 'Nov' },
      { id: 11, name: 'Dec' },
    ];

    this.fullMonths = [
      { id: 0, name: 'January' },
      { id: 1, name: 'February' },
      { id: 2, name: 'March' },
      { id: 3, name: 'April' },
      { id: 4, name: 'May' },
      { id: 5, name: 'June' },
      { id: 6, name: 'July' },
      { id: 7, name: 'August' },
      { id: 8, name: 'September' },
      { id: 9, name: 'October' },
      { id: 10, name: 'November' },
      { id: 11, name: 'December' },
    ];

    this.days = [
      { id: 1, name: 'Sunday' },
      { id: 2, name: 'Monday' },
      { id: 3, name: 'Tuesday' },
      { id: 4, name: 'Wednesday' },
      { id: 5, name: 'Thursday' },
      { id: 6, name: 'Friday' },
      { id: 7, name: 'Saturday' },
    ];

    this.years = this.getYearsFrom(2022);

    this.assetEntity = [
      { name: 'Truminds Software Systems Pvt Ltd' },
      { name: 'Truring Softek Private Limited' },
    ];

    setInterval(() => {
      const currentTime = new Date();
      this.currentTimeString = `${currentTime
        .getDate()
        .toString()
        .padStart(2, '0')}-${
        this.months[currentTime.getMonth()].name
      }-${currentTime.getFullYear()}, ${
        this.days[currentTime.getDay()].name
      }, ${currentTime.toTimeString().split(' ')[0]}`;
      this.timeForReportFile = `${currentTime.getDate()}_${(
        '0' +
        (currentTime.getMonth() + 1)
      ).slice(
        -2
      )}_${currentTime.getFullYear()}_${currentTime.getHours()}_${currentTime.getMinutes()}_${currentTime.getSeconds()}`;
    }, 1000);

    this.employeeExcelColumns = [
      { label: 'First Name', value: 'firstName' }, // Top level data
      { label: 'Last Name', value: 'lastName' }, // Custom format
      { label: 'Gender', value: 'gender.name' },
      { label: 'Employee Code', value: 'employeeCode' },
      { label: 'Projects', value: 'projects' },
      { label: 'Email', value: 'mailId' },
      { label: 'Reporting Manager', value: 'reportingManager' },
      { label: 'Employment Type', value: 'empEmploymentType.name' },
      { label: 'Grade', value: 'employeeGrade.name' }, //no need
      { label: 'Designation', value: 'designation.name' },
      { label: 'Domain', value: 'skillsDomain.name' },
      { label: 'Sub Domain', value: 'skillsSubDomain.name' },
      { label: 'Skills', value: 'keySkills' },
      { label: 'Base Location', value: 'baseLocation' },
      { label: 'Onboard Date', value: 'onboardDate' },
      { label: 'Experience On Onboard (yrs)', value: 'experienceOnOnboard' },
      { label: 'Experience (yrs)', value: 'currentExperience' },
      {
        label: 'Employee Category',
        value: (row: any) => row.employeeCategory && row.employeeCategory.name,
      },
      { label: 'Bench Ageing (Days)', value: 'benchStartDate' },
      {
        label: 'Blocked Status',
        value: (row: any) =>
          row.opportunityStatus && row.opportunityStatus.name,
      },
      { label: 'Blocked For', value: 'blockedFor' },
      { label: 'Blocked Date', value: 'blockDate' },
      { label: 'Remarks', value: 'remarks' },
      {
        label: 'Employee Status',
        value: (row: any) => row.employeeStatus && row.employeeStatus.name,
      },
      { label: 'Exit Date', value: 'exitDate' },
      { label: 'Exit Type', value: 'empExitType.name' },
      { label: 'Exit Remarks', value: 'empExitRemarks.name' },
      { label: 'Comments', value: 'additionalComments' },
    ];

    this.projectExcelColumns = [
      { label: 'Client ', value: 'client.clientName' }, // Top level data
      { label: 'Project Name', value: 'projectName' }, // Custom format
      { label: 'Project Manager', value: 'managerName' },
      { label: 'Technology', value: 'technology.name' },
      { label: 'Charge code', value: 'chargeCode' },
      { label: 'Nature of Project', value: 'natureOfProject.name' },
      { label: 'Business Model', value: 'businessModel.name' },
      { label: 'TSS Domain', value: 'tssDomain.name' },
      { label: 'Allocation', value: 'allocation' },
      { label: 'Billability', value: 'billability' },
      {
        label: 'Project Utilization',
        value: (row: any) => row.projectUtilization + '%',
      },
      { label: 'Project Status', value: (row: any) => row.projectStatus.name },
    ];

    this.clientExcelColumns = [
      { label: 'Client', value: 'clientName' }, // Top level data
      { label: 'Location', value: 'geo' }, // Custom format
      { label: 'Onboard Date', value: 'onBoardDate' },
      { label: 'SOW', value: 'sowName' },
      { label: 'SOW Value (In USD)', value: 'swoPrice' },
      {
        label: 'Business Model',
        value: (row: any) =>
          this.businessModals.filter((m: any) => {
            return m.code == row.businessModel;
          })[0]?.name,
      },
      {
        label: 'SOW location',
        value: (row: any) =>
          this.sowLocations.filter((m: any) => {
            return m.code == row.location;
          })[0]?.name,
      },
      { label: 'Contact Name', value: 'clientContactName' },
      { label: 'Contact Designation', value: 'clientContactDesignation' },
      { label: 'Contact Mail', value: 'clientContactMail' },
      { label: 'Contact Mobile', value: 'clientContactMobile' },
    ];

    this.sowExcelColumns = [
      { label: 'SOW', value: 'name' },
      { label: 'Value (In USD)', value: 'value' },
      { label: 'Start Date', value: 'startDate' },
      { label: 'End Date', value: 'endDate' },
      { label: 'Business Model', value: 'businessModel.name' },
      { label: 'Location', value: 'sowLocation.name' }, // Custom format
      { label: 'Client', value: 'clientRef.name' }, // Top level data
      { label: 'Status', value: 'isActive' },
    ];

    this.contactsExcelColumns = [
      { label: 'Client Name', value: 'clientRef.name' },
      { label: 'Contact Person', value: 'name' },
      { label: 'Mobile Number', value: 'mobileNumber' },
      { label: 'Email Id', value: 'mailId' },
      { label: 'Designation', value: 'designation' },
      { label: 'Location', value: 'location' },
    ];

    this.userExcelColumns = [
      { label: 'Name', value: 'name' },
      { label: 'Reporting Manager', value: 'reportingManager' },
      { label: 'Email ID', value: 'mail' },
      { label: 'Location', value: 'location' },
      { label: 'Role', value: 'role' },
      { label: 'Grade', value: 'employeeGrade' },
      { label: 'Assigned Projects', value: 'projectUnder' },
    ];

    this.employeeUserExcelColumns = [
      { label: 'Name', value: 'name' },
      { label: 'Reporting Manager', value: 'reportingManager' },
      { label: 'Email ID', value: 'mail' },
      { label: 'Location', value: 'location' },
      { label: 'Grade', value: 'employeeGrade' },
      { label: 'Designation', value: 'designation' },
      { label: 'Assigned Projects', value: 'projectUnder' },
    ];
  }

  getYearsFrom(startYear: number): number[] {
    const currentYear = new Date().getFullYear();
    return Array.from(
      { length: currentYear - startYear + 1 },
      (_, i) => startYear + i
    );
  }
}

export interface Subsets {
  id: number | string;
  code: string;
  name: string;
}

export interface SubsetsV2 {
  id: number | string;
  code: string;
  name: string;
  empExitRemarks: Subsets[];
}

export interface EmpSkillsGroup {
  domainId: number;
  label: string;
  options: EmpSubSkillsOption[];
}

export interface EmpSubSkillsOption {
  id: number;
  name: string;
}
